import { useState } from 'react';
import { PenLine } from 'lucide-react';

function SignatureRequestModal({ fileName, slotLabel, onConfirm, onClose }) {
  const [method, setMethod]         = useState('GOVBR');
  const [csLink, setCsLink]         = useState('');
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    if (method === 'CLICKSIGN' && !String(csLink).trim()) return;
    setConfirming(true);
    try { await onConfirm(method, method === 'CLICKSIGN' ? String(csLink).trim() : null); }
    finally { setConfirming(false); }
  };

  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-sm mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-[#20243B] px-5 py-4 flex items-center gap-3">
          <PenLine className="w-5 h-5 text-[#C5A059] flex-shrink-0" />
          <div>
            <div className="text-[11px] font-black uppercase tracking-widest text-[#C5A059]">Solicitar Assinatura</div>
            <div className="text-[10px] text-white/70 truncate max-w-[220px]">{String(slotLabel || fileName || '')}</div>
          </div>
        </div>
        <div className="px-5 py-4 space-y-3">
          <div className="grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setMethod('GOVBR')} className={`p-3 rounded-xl border-2 text-left transition-all ${method === 'GOVBR' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}>
              <div className="text-[10px] font-black uppercase tracking-widest text-blue-700">🏛 Gov.br</div>
              <div className="text-[9px] text-gray-500 mt-0.5">Custo zero · Fé pública · Padrão procurações</div>
            </button>
            <button type="button" onClick={() => setMethod('CLICKSIGN')} className={`p-3 rounded-xl border-2 text-left transition-all ${method === 'CLICKSIGN' ? 'border-[#C5A059] bg-amber-50' : 'border-gray-200 hover:border-[#C5A059]/50'}`}>
              <div className="text-[10px] font-black uppercase tracking-widest text-amber-700">✍️ Clicksign</div>
              <div className="text-[9px] text-gray-500 mt-0.5">Liveness · Contratos · Link de envelope</div>
            </button>
          </div>
          {method === 'CLICKSIGN' && (
            <div>
              <label className="text-[10px] font-bold text-gray-600 block mb-1">URL do Envelope Clicksign</label>
              <input type="url" placeholder="https://app.clicksign.com/sign/..." value={csLink} onChange={(e) => setCsLink(e.target.value)} className="w-full text-xs border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-[#C5A059]" />
            </div>
          )}
          {method === 'GOVBR' && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 text-[10px] text-blue-700">
              O cliente receberá uma notificação para assinar em <strong>assinador.iti.br</strong> com conta Gov.br (Nível Prata ou Ouro).
            </div>
          )}
        </div>
        <div className="px-5 pb-5 flex gap-2">
          <button type="button" onClick={onClose} className="flex-1 py-2 rounded-lg border border-gray-300 text-xs font-bold text-gray-600 hover:bg-gray-50 transition">Cancelar</button>
          <button type="button" onClick={handleConfirm} disabled={confirming || (method === 'CLICKSIGN' && !csLink.trim())} className="flex-1 py-2 rounded-lg bg-[#20243B] text-[#C5A059] text-xs font-extrabold uppercase tracking-widest hover:bg-[#2d3352] disabled:opacity-50 transition">
            {confirming ? 'Enviando...' : 'Solicitar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignatureRequestModal;
